export const accentColors = {
  accentOne: '#FF0046',
  accentTwo: '#E68699',
  accentThree: '#F2A900',
  accentFour: '#228300',
} as const;
